import React, { Component, PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import { CheckBoxField } from 'common/components/form_fields';
import Money from 'common/components/money';
import AnimatedButton from 'common/components/animated_button';
import AwardsTable from 'account/containers/payout/awards_table';
import { getNextPaymentDate } from 'common/ducks/payout';
import { sumAwards } from 'common/ducks/payout';

/* Simple wrapper around <AwardsTable /> so that it can be used as a redux-form field. */
const AwardsTableField = ({input, meta}) => (
  <div>
    <AwardsTable hideDate={true} selected={input.value} onToggle={input.onChange}
      onlyAvailable={true}/>

    {meta.error && meta.touched && <div className="callout alert">{meta.error}</div>}

    <div className="total">
      <h4>Total Payment</h4>
      <h2>
        <Money value={sumAwards(input.value)}/>
      </h2>
      <p>
        Payments can take up to 10 business days to reach your account after you
        schedule the payment.
      </p>
    </div>
  </div>
)

/**
 * Request payment form.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class RequestPaymentForm extends Component {

  render() {
    const {error, handleSubmit, submitting, submitFailed, onCancel} = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <h3>Schedule Payment</h3>
        <p>Select the awards for which you would like to receive payment.</p>

        <Field name="awards" component={AwardsTableField} />

        <Field name="accepted_terms" component={CheckBoxField}
          label={<span>
            I will not ask crowdspring about my payment until after 10 <strong>business </strong>
            days have passed.
          </span>} />

        <div className="modal-actions">
          <AnimatedButton processing={submitting} type="submit" label="Schedule"
            processingLabel="Scheduling..." errorMsg={error || submitFailed}
            successMsg="Done!"/>

          <button className="btn btn-text btn-block" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>);
  }
}

const validate = values => {
  const errors = {};

  if (values.awards.length == 0) {
    errors.awards = 'At least one award must be selected.';
  }

  if (!values.accepted_terms) {
    errors.accepted_terms = 'You must check this box before we can schedule your payment.';
  }

  return errors;
}

export default reduxForm({
  form: "RequestPayment",
  validate,
})(RequestPaymentForm);



// WEBPACK FOOTER //
// ./account/components/payout/request_payment_form.jsx